import React, { useState, useEffect } from 'react';
import { userAppData } from '../MainApp.js';
import './OncallDesktop.css';
import './OncallMobile.css';
import LoadingComp from '../common/loading.js';
import { ApiError } from '../common/apiError.js';
import { OnCallCompleteCall } from './OnCallCompleteCall.js';
import { SEC_ApiCall, sortArrayByNumericalProperty } from '../func.js';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import Select from 'react-select';


export default function OncallPreviousRequests() {
    const [dataState, setDataState] = useState([]);
    const [callTypesState, setCallTypesState] = useState([]);
    const [dataFilteredState, setDataFilteredState] = useState([]);
    const [isLoadedState, setIsLoadedState] = useState(false);
    const [apiErrorState, setApiErrorState] = useState(null);
    const [apiErrorTextState, setApiErrorTextState] = useState('');
    const [postApiErrorState, setPostApiErrorState] = useState(null);
    const [resultsPerPageState, setResultsPerPageState] = useState(10);
    const [currentPageState, setCurrentPageState] = useState(1);
    const [numberOfPagesState, setNumberOfPagesState] = useState(1);
    const [pageDataState, setPageDataState] = useState(null);
    const [pupilsFilterState, setPupilsFilterState] = useState([]);
    const [selectedPupilState, setSelectedPupilState] = useState('All');
    const [hasMoreState, setHasMoreState] = useState(false);
    const [nextCursorState, setNextCursorState] = useState('');
    const [loadingMoreState, setLoadingMoreState] = useState(false);

    function paginate(array, page_size, page_number) {
        // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    function buildPupilOptions(records) {
        const pupilArray = ['All'];
        const pupilDict = [];

        for (const record of records) {
            const pupilName = record['pupilId'];
            if (!pupilArray.includes(pupilName)) {
                pupilArray.push(pupilName);
            }
        }

        for (const name of pupilArray) {
            pupilDict.push({ label: name, value: name });
        }

        return pupilDict;
    }

    function applySelectedFilter(records, selectedPupil) {
        if (selectedPupil === 'All') {
            return records;
        }

        return records.filter((record) => record['pupilId'] === selectedPupil);
    }

    function updateDisplayedData(records, selectedPupil, requestedPage = 1) {
        const sortedRecords = sortArrayByNumericalProperty(records, 'submissionEpoch', 'decending');
        const filteredRecords = applySelectedFilter(sortedRecords, selectedPupil);
        const resultsPerPage = Number(resultsPerPageState);
        const totalPages = Math.max(1, Math.ceil(filteredRecords.length / resultsPerPage));
        const safePage = Math.min(requestedPage, totalPages);

        setDataState(sortedRecords);
        setDataFilteredState(filteredRecords);
        setNumberOfPagesState(totalPages);
        setCurrentPageState(safePage);
        setPageDataState(paginate(filteredRecords, resultsPerPage, safePage));
        setPupilsFilterState(buildPupilOptions(sortedRecords));
    }

    async function apiCall(params, appendResults = false, requestedPage = 1) {
        var url = 'oncall/archive';
        try {
            const response = await SEC_ApiCall(url, params, setApiErrorState);
            const responseData = Array.isArray(response['data']) ? response['data'] : [];
            const combinedRecords = appendResults
                ? [...dataState, ...responseData.filter((incomingItem) => !dataState.some((existingItem) => existingItem.id === incomingItem.id))]
                : responseData;

            setCallTypesState(response["callTypes"]);
            setHasMoreState(Boolean(response['hasMore']));
            setNextCursorState(response['nextCursor'] || '');
            updateDisplayedData(combinedRecords, selectedPupilState, requestedPage);
            setIsLoadedState(true);
        } catch (e) {
            setIsLoadedState(true);
            console.log(e);
            setApiErrorState('error');
            setApiErrorTextState(e);
        }
    };

    function onResultsSelectorChange(event) {
        var querySelect = Number(event.target.value);
        setResultsPerPageState(querySelect);
        const totalPages = Math.max(1, Math.ceil(dataFilteredState.length / querySelect));
        setNumberOfPagesState(totalPages);
        setCurrentPageState(1);
        setPageDataState(paginate(dataFilteredState, querySelect, 1));
    }

    async function loadMoreArchivedCalls(targetPage) {
        if (!hasMoreState || !nextCursorState || loadingMoreState) {
            return;
        }

        setLoadingMoreState(true);
        try {
            await apiCall({ pageSize: 50, cursor: nextCursorState }, true, targetPage);
        } finally {
            setLoadingMoreState(false);
        }
    }

    async function nextPage() {
        let currentPage = currentPageState;
        if (currentPage >= numberOfPagesState) {
            if (hasMoreState) {
                await loadMoreArchivedCalls(currentPage + 1);
            } else {
                setCurrentPageState(currentPage);
            }
        } else {
            let nextPage = currentPage + 1;
            setCurrentPageState(nextPage);
            let pageData = paginate(dataFilteredState, Number(resultsPerPageState), nextPage)
            setPageDataState(pageData);
        }
    }

    function prevPage() {
        let currentPage = currentPageState;
        if (currentPage > 1) {
            let nextPage = currentPage - 1;
            setCurrentPageState(nextPage);
            let pageData = paginate(dataFilteredState, Number(resultsPerPageState), nextPage)
            setPageDataState(pageData);
        } else {
            setCurrentPageState(1);
        }
    }

    function applyFilter(pupil) {
        let requiredName = pupil?.value || 'All';
        setSelectedPupilState(requiredName);
        updateDisplayedData(dataState, requiredName, 1);
    }

    useEffect(() => {
        var params = { pageSize: 50 };
        apiCall(params);
    }, []);


    if (!isLoadedState) {
        return (
            <div className='main_div'>
                <LoadingComp />
            </div>
        )
    } else if (apiErrorState) {
        return (
            <ApiError />
        )
    } else {
        return (
            <div className='main_div'>
                <div className='internal_main_div'>
                    <div className='oncall_header_div'>
                        <h1 className='admin_header' >OnCall Archived Requests</h1>
                        <div className='requestTableHeaderItem3'>
                            <span className="requestsPerPageLabel">Requests per page</span>
                            <select className='resultsPerPageSelector' defaultValue="10" onChange={onResultsSelectorChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>

                    <div className='oncall_filter_div'>
                        <span className="requestsPerPageLabel">Learner Filter</span>
                        <Select
                            className='oncall_filter_Selector'
                            maxMenuHeight={'200px'}
                            options={pupilsFilterState}
                            placeholder='All'
                            noOptionsMessage={() => 'Unable to find a record of the learner'}
                            onChange={(e) => applyFilter(e)}
                            isSearchable
                        />

                    </div>

                    <div className='oncall_calls_main_div'>
                        <div className='oncall_calls_complete_calls_div'>
                            {pageDataState.map((item) =>
                                <OnCallCompleteCall
                                    key={item["id"]}
                                    data={item}
                                    showPupilId={true}
                                    callTypes={callTypesState}
                                    apiCall={apiCall}
                                />
                            )
                            }
                        </div>
                    </div>

                    {hasMoreState && (
                        <div className="nextRequestPageDiv">
                            <div className="pageNumberButtons" onClick={() => !loadingMoreState && loadMoreArchivedCalls(currentPageState)}>
                                {loadingMoreState ? '...' : 'Load More'}
                            </div>
                        </div>
                    )}

                    <div className="nextRequestPageDiv">
                        <div className="pageNumberButtons" onClick={prevPage}><FaArrowLeft color="#fb9233" /></div><div className="pageNumberDiv">{currentPageState} / {numberOfPagesState}</div><div className="pageNumberButtons" onClick={nextPage}><FaArrowRight color="#fb9233" /></div>
                    </div>

                </div>
            </div>

        )
    }
};
